import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const kibana = defineConnector({
  identifier: "kibana",
  name: "Kibana",
  tagLine: "Elastic dashboards and management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ url }) =>
    url ? `${url}/.*` : "https://kibana\\.example\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "ApiKey",
      },
    ]),
  steps: [
    {
      title: "Create a Kibana API key",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://www.elastic.co/docs/api/doc/kibana/authentication](https://www.elastic.co/docs/api/doc/kibana/authentication) to create a Kibana API key. Elastic documents API key auth as `Authorization: ApiKey base64AccessApiKey`.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "url",
          label: "Kibana base URL",
          placeholder: "https://kibana.example.com",
          required: true,
          target: {
            kind: "configuration",
            field: "url",
          },
        },
        {
          kind: "input",
          label: "Base64 API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://kibana.example.com/health",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url: testUrl ?? (({ url }) => `${url}/api/status`)(configuration),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
